var _path, _path2, _path3, _path4, _path5, _g, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYiddish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 660,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h660v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 45h660v75H0zM0 360h660v75H0zM230.694 172.92a99.306 99.306 0 1 0 198.612 0h-9.455a89.851 89.851 0 1 1-179.702 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.256 173.35a70.744 70.744 0 1 0 141.488 0h-9.521a61.223 61.223 0 1 1-122.446 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.157 172.92a41.843 41.843 0 1 0 83.686 0h-9.455a32.388 32.388 0 1 1-64.776 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.562 317.879v6.471h102.876v-6.471l-46.711-10.413V165.639h-9.454v141.827z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M223.357 161.017h24.132l-7.338 9.917h-9.455z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 28.731
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 57.461
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 94.577,
    y: -7.261
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 131.693
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYiddish);
export default __webpack_public_path__ + "static/media/yiddish.2c0685226e22e5cac6dc8c27917b19fe.svg";
export { ForwardRef as ReactComponent };